export class StringHelpers {
    static indexOfSubstring(text: string, searchText: string): number {
        return text.toLowerCase().indexOf(searchText.toLowerCase());
    }

    static equalSubstring(text: string, searchText: string): boolean {
        return text.toLowerCase() === searchText.toLowerCase();
    }
}
